export const TIPO_LOGS = [
    { value: 3, label: "Empresa", buscar: "RUC" },
    { value: 2, label: "Persona", buscar: "Cédula" },
    { value: 1, label: "Placa", buscar: "Placa" },
];
